import { Box, styled } from "@mui/material";
import { toolbarButtonName } from "../classes.js";
const Icon = styled(Box, {
  name: toolbarButtonName,
  slot: "Icon",
  overridesResolver: (_props, styles) => [styles.icon]
})(({ theme }) => ({
  alignItems: "center",
  borderRadius: "50%",
  display: "flex",
  flexDirection: "column",
  height: theme.spacing(6),
  justifyContent: "center",
  transition: "background 0.2s cubic-bezier(0.17, 0.67, 0.55, 1.09)",
  width: theme.spacing(6)
}));
export {
  Icon
};
//# sourceMappingURL=Icon.js.map
